import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Generate build version (YYYYMMDD-HHMM-SEQ format)
const now = new Date();
const dateStr = now.toISOString().slice(0, 10).replace(/-/g, '');
const timeStr = now.toISOString().slice(11, 16).replace(':', '');
const sequence = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
const BUILD_VERSION = `${dateStr}-${timeStr}-${sequence}`;

console.log(`🎮 Duel DApp Frontend v${BUILD_VERSION}`);
console.log(`📅 Build Time: ${now.toISOString()}`);
console.log(`🌐 Environment: ${import.meta.env.MODE}`);

// StrictMode temporarily removed - causes Modal state issues in development (double rendering)
// import React from 'react'
// <React.StrictMode><App /></React.StrictMode>
ReactDOM.createRoot(document.getElementById('root')!).render(
  <App />
)

